import {
  CHECK24_EXTRA_NON_PROD_DOMAINS,
  CHECK24_LOCAL_HOSTNAMES,
  CHECK24_NON_PROD_DOMAIN,
  CHECK24_PROD_DOMAIN,
} from './check24-environment.config';

export type Check24Deployment = 'prod' | 'non-prod';

const NON_PROD_DOMAIN_SUFFIXES = [
  CHECK24_NON_PROD_DOMAIN,
  ...CHECK24_EXTRA_NON_PROD_DOMAINS,
] as const;

function hostOnDomain(hostname: string, domain: string): boolean {
  return hostname === domain || hostname.endsWith(`.${domain}`);
}

export function check24DeploymentFromHostname(
  hostname: string,
): Check24Deployment {
  if ((CHECK24_LOCAL_HOSTNAMES as readonly string[]).includes(hostname)) {
    return 'non-prod';
  }
  if (NON_PROD_DOMAIN_SUFFIXES.some((domain) => hostOnDomain(hostname, domain))) {
    return 'non-prod';
  }
  return 'prod';
}

export function isCheck24Prod(hostname = window.location.hostname): boolean {
  return check24DeploymentFromHostname(hostname) === 'prod';
}

export function check24WwwOrigin(
  deployment: Check24Deployment = check24DeploymentFromHostname(
    window.location.hostname,
  ),
): string {
  const domain =
    deployment === 'prod' ? CHECK24_PROD_DOMAIN : CHECK24_NON_PROD_DOMAIN;
  return `https://www.${domain}`;
}

export function check24KreditAppHostname(
  deployment: Check24Deployment = check24DeploymentFromHostname(
    window.location.hostname,
  ),
): string {
  const domain =
    deployment === 'prod' ? CHECK24_PROD_DOMAIN : CHECK24_NON_PROD_DOMAIN;
  return `kredit.${domain}`;
}

export function check24ImagesHostname(
  deployment: Check24Deployment = check24DeploymentFromHostname(
    window.location.hostname,
  ),
): string {
  const domain =
    deployment === 'prod' ? CHECK24_PROD_DOMAIN : CHECK24_NON_PROD_DOMAIN;
  return `images.www.${domain}`;
}

export function isAllowedCheck24ImagesHost(hostname: string): boolean {
  const allowed = [
    check24ImagesHostname('prod'),
    check24ImagesHostname('non-prod'),
    ...CHECK24_EXTRA_NON_PROD_DOMAINS.map((d) => `images.www.${d}`),
  ];
  return allowed.includes(hostname);
}
